import {
  DATETYPE,
  GrowthIndex,
  DurationType,
  PensionOptionType,
  WithdrawalIndex,
  AdvanceSuperFilter,
  DefaultRetirementDate,
  OptionIndex,
  FeeTypeIndex,
} from "../helpers/constant";
import { CommonHelper } from "../helpers";
import {
  SET_LOADER_VISIBILITY,
  GET_CLIENT_INFORMATION,
} from "../helpers/vuex-constants";
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    baselineFilterObject() {
      return Object.assign({}, this.baselineData);
    },

    ...mapGetters({
      getClientInformation: GET_CLIENT_INFORMATION,
    }),
  },
  methods: {
    ...mapActions({
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    checkerror(Row) {
      for (var key of Object.keys(Row)) {
        if (Row[key].IsError != undefined && Row[key].IsError == true) {
          if (key == "startDate") return "startDateType";
          if (key == "endDate") return "endDateType";

          return key;
        }
      }
      return "";
    },
    ResetMonthPickerValue(rows) {
      if (rows) {
        for (let i = 0; i < rows.length; i++) {
          if (rows[i].endDate && typeof rows[i].endDate.value == "object") {
            rows[i].endDateType.value = rows[i].endDate.value.value;
            rows[i].endDate.value = rows[i].endDate.value.meta;
          }
          if (typeof rows[i].startDate.value == "object") {
            rows[i].startDateType.value = rows[i].startDate.value.value;
            rows[i].startDate.value = rows[i].startDate.value.meta;
          }
        }
      }
      return rows;
    },
    setErrorFocus() {
      let firstFocusElement = "";

      for (let i = 0; i < this.singleHeadingOptions.length; i++) {
        let Row = this.rows.filter(
          (x) => x.subTypeId.value == this.singleHeadingOptions[i].key
        );
        for (let l = 0; l < Row.length; l++) {
          let key = this.checkerror(Row[l]);
          if (key != "") {
            firstFocusElement = key + this.singleHeadingOptions[i].key + l;
          }
        }
      }
      this.focusElementName = firstFocusElement;
    },
    getTimeSeriesXAxisData(projectionYear) {
      let ProjectionDate = new Date(this.ProjectionDate);
      let startYear = ProjectionDate.getFullYear();
      return [startYear, startYear + projectionYear.Value];
    },
    getStartMonthYear(date, yearRange) {
      if (!date || date == "") {
        return [1, yearRange[0]];
      } else {
        let monthrange = date.split("/");
        return [parseInt(monthrange[0]), parseInt(monthrange[1])];
      }
    },
    getEndMonthYear(date) {
      if (!date || date == "") {
        return undefined;
      } else {
        let monthrange = date.split("/");
        return [parseInt(monthrange[0]), parseInt(monthrange[1])];
      }
    },
    validatebyrow(row, subtypeid) {
      let Error = true;
      for (
        let i = 0;
        i <
        this.singleHeadingOptions.filter((x) => x.key == subtypeid)[0].fields
          .length;
        i++
      ) {
        let key = this.singleHeadingOptions.filter((x) => x.key == subtypeid)[0]
          .fields[i];
        let isRequired = this.headers.filter((x) => x.key == key)[0].validation;
        let isNumber = this.headers.filter((x) => x.key == key)[0]
          .isAllowOnlyNumber;

        if (
          (isRequired && row[key].value != "" && !isNumber) ||
          (row[key].value != "0" && isNumber)
        ) {
          Error = false;
        }
      }
      return Error;
    },

    indexOptions() {
      return [
        {
          text: "AWOTE",
          value: GrowthIndex.AWOTE,
        },
        {
          text: "CPI",
          value: GrowthIndex.CPI,
        },
        {
          text: "None",
          value: GrowthIndex.NONE,
        },
      ];
    },
    WithdrawalOptions() {
      return [
        {
          text: "Contribution",
          value: WithdrawalIndex.CONTRIBUTION,
        },
        {
          text: "Salary Sacrifice",
          value: WithdrawalIndex.SALARYSACRIFICE,
        },
        {
          text: "Non-Concessional",
          value: WithdrawalIndex.NONCONCESSIONAL,
        },
      ];
    },
    typeOptions() {
      return [
        {
          text: "Platform",
          value: FeeTypeIndex.Platform,
        },
        {
          text: "Admin",
          value: FeeTypeIndex.Admin,
        },
        {
          text: "Insurance",
          value: FeeTypeIndex.Insurance,
        },
        {
          text: "Other",
          value: FeeTypeIndex.Other,
        },
      ];
    },
    investmentFeeTypeOptions() {
      return [
        {
          text: "Platform",
          value: FeeTypeIndex.Platform,
        },
        {
          text: "Admin",
          value: FeeTypeIndex.Admin,
        },
        {
          text: "Other",
          value: FeeTypeIndex.Other,
        },
      ];
    },
    OptionOptions() {
      return [
        {
          text: "% only",
          value: OptionIndex.PersentOnly,
        },
        {
          text: "$ only",
          value: OptionIndex.AmountOnly,
        },
        {
          text: "% with $ cap",
          value: OptionIndex.PersentWithAmountCap,
        },
      ];
    },
    PensionTypeOptions() {
      return [
        {
          text: "Minimum",
          value: PensionOptionType.Minimum,
        },
        {
          text: "Other",
          value: PensionOptionType.Other,
        },
        {
          text: "Optimise",
          value: PensionOptionType.Optimise,
        },
      ];
    },
    monthOptions() {
      return [
        {
          text: "01",
          value: "1",
        },
        {
          text: "02",
          value: "2",
        },
        {
          text: "03",
          value: "3",
        },
        {
          text: "04",
          value: "4",
        },
        {
          text: "05",
          value: "5",
        },
        {
          text: "06",
          value: "6",
        },
        {
          text: "07",
          value: "7",
        },
        {
          text: "08",
          value: "8",
        },
        {
          text: "09",
          value: "9",
        },
        {
          text: "10",
          value: "10",
        },
        {
          text: "11",
          value: "11",
        },
        {
          text: "12",
          value: "12",
        },
      ];
    },
    startOptionsNew() {
      const client = this.$store.state.root.clientInformation.filter(
        (x) => x.entityType == 1
      )[0];
      const partner = this.$store.state.root.clientInformation.filter(
        (x) => x.entityType == 2
      )[0];
      let data = [
        {
          text: "Start",
          value: DATETYPE.Start,
          meta: "07/2025",
        },
        {
          text: "Start FY",
          value: DATETYPE.Start_Fy,
          meta: "07/2025",
        },
        {
          text: "Max",
          value: DATETYPE.Max,
          meta: "07/2053",
        },
        {
          text: "Client Retirement",
          value: DATETYPE.Client_Retirement,
          meta: CommonHelper.getRetirementMonthAndYear(
            client.dob,
            this.baselineData.ownerDetails
              ? this.baselineData.ownerDetails.filter(
                  (m) => m.clientId == client.clientId
                )[0].retirementAge
              : DefaultRetirementDate
          ),
        },
        {
          text: "Other",
          value: DATETYPE.Other,
          meta: "",
        },
      ];
      if (partner) {
        data.push({
          text: "Partner Retirement",
          value: DATETYPE.Partner_Retirement,
          meta: CommonHelper.getRetirementMonthAndYear(
            partner.dob,
            this.baselineData.ownerDetails
              ? this.baselineData.ownerDetails.filter(
                  (m) => m.clientId == partner.clientId
                )[0].retirementAge
              : DefaultRetirementDate
          ),
        });
      }
      return data;
    },
    setFocus() {
      let chartContainerElement = this.$el.getElementsByClassName(
        this.chartContainer
      );
      if (chartContainerElement && chartContainerElement.length > 0) {
        chartContainerElement[0].scrollIntoView({ behavior: "smooth" });
      }
    },
    frequencyOptionForSuperFee() {
      return [
        {
          text: "Weekly",
          value: DurationType.Weeks,
        },
        {
          text: "Fortnightly",
          value: DurationType.Fortnights,
        },
        {
          text: "Monthly",
          value: DurationType.Months,
        },
        {
          text: "Half Yearly",
          value: DurationType.Half_Year,
        },
        {
          text: "Yearly",
          value: DurationType.Years,
        },
      ];
    },
    frequencyOption() {
      return [
        {
          text: "Weekly",
          value: DurationType.Weeks,
        },
        {
          text: "Fortnightly",
          value: DurationType.Fortnights,
        },
        {
          text: "Monthly",
          value: DurationType.Months,
        },
        // {
        //   text: "Half Yearly",
        //   value: DurationType.Half_Year,
        // },
        // {
        //   text: "Yearly",
        //   value: DurationType.Years,
        // },
      ];
    },
    fillInvestmentModel(typeId) {
      if (this.baselineFilterObject.advancedetails == null) {
        this.baselineFilterObject.advancedetails = this.getUserInputData(
          this.rows
        );
      } else {
        let data = this.baselineFilterObject.advancedetails.filter(
          (sr) => sr.typeId.value != typeId
        );
        let advancedetails = data.concat(this.getUserInputData(this.rows));
        this.baselineFilterObject.advancedetails = advancedetails;
      }

      this.$emit("resetBaselineData", this.baselineFilterObject);
    },

    getinsertEmptyRows(currentRows, splitid = "subTypeId") {
      if (this.singleHeadingOptions)
        for (let i = 0; i < this.singleHeadingOptions.length; i++) {
          if (
            currentRows.filter(
              (x) => x[splitid].value == this.singleHeadingOptions[i].key
            ).length == 0
          )
            currentRows.push(
              this.fillData(undefined, this.singleHeadingOptions[i].key)
            );
        }
    },
    startOptions() {
      return [
        {
          text: "Start",
          value: DATETYPE.Start,
        },
        {
          text: "Start FY",
          value: DATETYPE.Start_Fy,
        },
        {
          text: "Max",
          value: DATETYPE.Max,
        },
        {
          text: "Client Retirement",
          value: DATETYPE.Client_Retirement,
        },
        {
          text: "Partner Retirement",
          value: DATETYPE.Partner_Retirement,
        },
        {
          text: "Other",
          value: DATETYPE.Other,
        },
      ];
    },
    yearOption() {
      let statYear = 2022;
      let yearOptions = [];
      for (let i = statYear; i < statYear + 50; i++) {
        yearOptions.push({ text: i.toString(), value: i.toString() });
      }
      return yearOptions;
    },
    endOptions() {
      return [
        {
          text: "Start",
          value: DATETYPE.Start,
        },
        {
          text: "Start FY",
          value: DATETYPE.Start_Fy,
        },
        {
          text: "Max",
          value: DATETYPE.Max,
        },
        {
          text: "Client Retirement",
          value: DATETYPE.Client_Retirement,
        },
        {
          text: "Partner Retirement",
          value: DATETYPE.Partner_Retirement,
        },
        {
          text: "Other",
          value: DATETYPE.Other,
        },
      ];
    },
    enableResetButton(isFormChanges, key) {
      if (this.gridButtonTemplatedata) {
        let resetButtomIndex = this.gridButtonTemplatedata.findIndex(
          (sr) => sr.key == key
        );
        if (resetButtomIndex >= 0) {
          this.gridButtonTemplatedata[resetButtomIndex].isdisabled =
            isFormChanges;
        }
      }
    },
    enableNonSuperResetButton(isFormChanges, key) {
      if (this.gridButtonTemplatedata) {
        let resetButtomIndex = this.gridButtonTemplatedata.findIndex(
          (sr) => sr.key == key
        );
        if (resetButtomIndex.length >= 1) {
          this.gridButtonTemplatedata[resetButtomIndex].isdisabled =
            isFormChanges;
        }
      }
    },

    genericMethodClick(function_name, data, rowindex) {
      if (function_name) {
        this[function_name](data, rowindex);
      }
    },
    fillSuperannuationModel(typeId) {
      if (this.rows) {
        if (this.baselineFilterObject.superAddtionalDetails == null) {
          this.baselineFilterObject.advancedetails = this.getUserInputData(
            this.rows
          );
        } else {
          let data = this.baselineFilterObject.superAddtionalDetails.filter(
            (sr) =>
              sr.typeId.value != typeId || sr.clientID.value != this.clientId
          );
          let advancedetails = data.concat(this.getUserInputData(this.rows));
          this.baselineFilterObject.superAddtionalDetails = advancedetails;
        }
      }

      this.$emit("resetBaselineData", this.baselineFilterObject);
    },
    AddNewTypeRow(data) {
      let splitid = this.gridSplitId == "" ? 1 : data.key;
      this.focusElementName = "";
      this.rows.push(this.fillData(undefined, data.key));
      let splitRows = this.rows.filter((x) => x.subTypeId.value == data.key);
      let newIndex = splitRows.length - 1;

      let previousEndDate = splitRows[newIndex - 1].endDate.value.meta
        ? splitRows[newIndex - 1].endDate.value.meta
        : splitRows[newIndex - 1].endDate.value;
      if (previousEndDate != "") {
        let nextDate = CommonHelper.getNextDate(previousEndDate);
        let DateData = {
          text: "Other",
          value: DATETYPE.Other,
          meta: nextDate,
        };
        splitRows[newIndex].startDate.value = DateData;
        this.rows = this.emptyGridRow(this.rows);
        // this.rows[newIndex].endDate.value.meta = nextDate;
        // this.rows[newIndex].endDate.value.text = "Other";
        // this.rows[newIndex].endDate.value.value = DATETYPE.Other;
      }

      let firstElement =
        this.singleHeadingOptions.filter((x) => x.key == data.key)[0]
          .fields[0] +
        splitid +
        newIndex;
      setTimeout(() => {
        this.focusElementName = firstElement;
        this.scrollBottom();
      }, 100);
      // this.rows.filter((x) => x.subTypeId.value == data.key)[index][DateType][
      //   key
      // ]
    },
    scrollBottom() {
      document.querySelector("#advancesettingswrapperdiv").scrollTop =
        document.querySelector("#advancesettingswrapperdiv").clientHeight;
    },
    updateDataRow(index, subtype, key, value) {
      this.rows.filter((x) => x.subTypeId.value == subtype)[index][key].value =
        value;
    },
    updateDatainRow(index, subtype, key, value, DateType) {
      this.rows.filter((x) => x.subTypeId.value == subtype)[index][DateType][
        key
      ] = value;
    },
    OnOptionChange(data) {
      let UpdateincomeKey = "";
      let UpdategrowthKey = "";
      let UpdatefrankingKey = "";
      let updateRiskProfileId = "";

      let index = data.index;
      let rowSubtype = data.row != undefined ? data.row.subTypeId.value : 1;
      //  let typeId = data.row != undefined ? data.row.typeId.value : AdvanceSuperFilter.WithdrawalPension;
      let changedvalue = data.event;
      let baseRiskProfileData = Object.assign(
        [],
        this.baselineData.riskProfileOption
      );
      let clientRiskProfile = baseRiskProfileData.filter(
        (sr) => sr.value == changedvalue
      );
      if (data.key.toLowerCase() == "riskprofile") {
        if (clientRiskProfile.length != 0) {
          UpdateincomeKey = clientRiskProfile[0].incomeRate;
          UpdategrowthKey = clientRiskProfile[0].growthRate;
          UpdatefrankingKey = clientRiskProfile[0].frankingRate;
        }
        this.updateDataRow(index, rowSubtype, "amount1", UpdateincomeKey);
        this.updateDataRow(index, rowSubtype, "amount2", UpdategrowthKey);
        this.updateDataRow(index, rowSubtype, "amount3", UpdatefrankingKey);
      }
      if (
        data.key.toLowerCase() == "amount1" ||
        data.key.toLowerCase() == "amount2" ||
        data.key.toLowerCase() == "amount3"
      ) {
        updateRiskProfileId = 0;
        this.updateDataRow(
          index,
          rowSubtype,
          "riskProfile",
          updateRiskProfileId
        );
      }
      let subtype = data.row != undefined ? data.row.subTypeId.value : 1;
      if (data.key.toLowerCase() == "supertypeid") {
        if (
          data.row != undefined &&
          data.row.typeId.value == AdvanceSuperFilter.PensionPayment
        )
          if (changedvalue != PensionOptionType.Other) {
            this.updateDatainRow(index, subtype, "disable", true, "amount1");
          } else {
            this.updateDatainRow(index, subtype, "disable", false, "amount1");
          }
        this.updateDatainRow(index, subtype, "value", "0", "amount1");
      }
      //  if(data.key.toLowerCase() == "supertypeid" && typeId == AdvanceSuperFilter.WithdrawalPension){
      //   if(changedvalue == 1|| changedvalue == 3){
      //     this.updateDatainRow(index, rowSubtype, "disable", true,"amount1");
      //     this.updateDataRow(index, rowSubtype, "amount1",0);
      //   }
      //   else{
      //     this.updateDatainRow(index, rowSubtype, "disable", false,"amount1");
      //     this.updateDatainRow(index, rowSubtype, "amount1",0);
      //   }
      // }
    },
    addRow(index, subtypeid) {
      this.rows.splice(index + 1, 0, this.fillData(undefined, subtypeid));
      this.focusElementName = "";

      let newIndex =
        this.rows.filter((x) => x.subTypeId.value == subtypeid).length - 1;
      let firstElement =
        this.singleHeadingOptions.filter((x) => x.key == subtypeid)[0]
          .fields[0] +
        subtypeid +
        newIndex;
      setTimeout(() => {
        this.focusElementName = firstElement;
        this.scrollBottom();
      }, 100);
    },
  },
};
